import { render, staticRenderFns } from "./addAppCustom.vue?vue&type=template&id=4628b34d&scoped=true&"
import script from "./addAppCustom.vue?vue&type=script&lang=js&"
export * from "./addAppCustom.vue?vue&type=script&lang=js&"
import style0 from "./addAppCustom.vue?vue&type=style&index=0&id=4628b34d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4628b34d",
  null
  
)

component.options.__file = "addAppCustom.vue"
export default component.exports